module.exports = __webpack_public_path__ + "static/media/cerca_officine.c62dd229.svg";